import {createFileRoute} from "@tanstack/react-router"
import {CurrentMonth} from "@/components/MonthInfo/CurrentMonth.tsx"

export const Route = createFileRoute("/_mainLayout/current_month/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CurrentMonth/>
  );
}
